(function ($, Drupal, window, document) {

  'use strict';

  Drupal.behaviors.work_teaser_big = {
    attach: function (context, settings) {
        $('.work-media').slick({
            arrows: true,
            fade: false,
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: "<span class='arrow-prev'><span class='icon--angle-left'></span></span>",
            nextArrow: "<span class='arrow-next'><span class='icon--angle-right'></span></span>",
        });

        $('.work-media-captions .captions').slick({
            arrows: false,
            fade: true,
            swipe: false,
        });

        // On before slide change
        $('.work-media').on('afterChange', function(event, slick, currentSlide){
            $(this).parent().parent().parent().find('.captions').slick('slickGoTo', currentSlide);
        });
    }
  };

})(jQuery, Drupal, this, this.document);
